import { render, staticRenderFns } from "./PhoneValid.vue?vue&type=template&id=0db2ac68&scoped=true&"
import script from "./PhoneValid.vue?vue&type=script&lang=js&"
export * from "./PhoneValid.vue?vue&type=script&lang=js&"
import style0 from "./PhoneValid.vue?vue&type=style&index=0&id=0db2ac68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db2ac68",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QField});
